import { render, staticRenderFns } from "./FavouriteLotsShortList.vue?vue&type=template&id=5cf63134&scoped=true&"
import script from "./FavouriteLotsShortList.vue?vue&type=script&lang=js&"
export * from "./FavouriteLotsShortList.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteLotsShortList.vue?vue&type=style&index=0&id=5cf63134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf63134",
  null
  
)

export default component.exports